export default "__VITE_ASSET__e57cd7b0__"